var map = {
	"./1.png": "a8b0",
	"./2.png": "7244",
	"./3.png": "035a",
	"./4.png": "eee3",
	"./5.png": "e86e",
	"./6.png": "3968",
	"./7.png": "51c7",
	"./art2.png": "bece",
	"./art4.png": "5b9c",
	"./art5.png": "5d79",
	"./art6.png": "8f28"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "77c3";